module.exports = {

  tips: "Semgregate AI Tips & Tricks",
  tipApplyFilter: "Apply Filter!",
  tipsSummary: (count) => `Our system generated ${count} ${count>1 ? 'tips' : 'tip'} for you`

}


// WEBPACK FOOTER //
// ../i18n/en/tips.js